export enum ButtonStyle {
  Basic = 'basic',
  Stroked = 'stroked',
  Accent = 'accent'
}
